module.exports = __webpack_public_path__ + "img/Sphinx riddle.a013c308.webp";